import React, { useState } from 'react';
import { Search, Download, LogOut } from 'lucide-react';
import { dashboardApi } from '../services/api';

const Header = ({ user, onSignOut }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleExport = async () => {
    try {
      const response = await dashboardApi.exportCSV();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `influencers-${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Export failed:', error);
      alert('Failed to export data');
    }
  };

  return (
    <header className="bg-white shadow-sm">
      <div className="flex items-center justify-between px-6 py-4">
        <div className="flex items-center flex-1 max-w-2xl">
          <div className="relative w-full">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              type="text"
              placeholder="Search influencers..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
        <button
          onClick={handleExport}
          className="ml-4 flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          <Download className="w-4 h-4 mr-2" />
          Export CSV
        </button>
      </div>
          {user && (
        <div className="flex items-center ml-auto pl-4">
          <span className="text-sm text-gray-600 mr-3">{user.username}</span>
          <button
            onClick={onSignOut}
            className="flex items-center px-3 py-1.5 text-sm text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50"
          >
            <LogOut className="w-4 h-4 mr-1.5" /> Sign out
          </button>
        </div>
      )}
</header>
  );
};

export default Header;
